/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Details_Archive_Reason_SoldInputs */

const fr_vehicle_details_archive_reason_sold = /** @type {(inputs: Vehicle_Details_Archive_Reason_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a été vendu`)
};

const en_vehicle_details_archive_reason_sold = /** @type {(inputs: Vehicle_Details_Archive_Reason_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`was sold`)
};

/**
* | output |
* | --- |
* | "was sold" |
*
* @param {Vehicle_Details_Archive_Reason_SoldInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_details_archive_reason_sold = /** @type {((inputs?: Vehicle_Details_Archive_Reason_SoldInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Details_Archive_Reason_SoldInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_details_archive_reason_sold(inputs)
	return en_vehicle_details_archive_reason_sold(inputs)
});